import { HttpEventType, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';

import { Logger } from '../../logging/logger.service';

const CORRELATION_HEADER = 'X-Correlation-Id';

export const httpLoggingInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(Logger);
  const startedAt = performance.now();
  const correlationId = req.headers.get(CORRELATION_HEADER) ?? undefined;

  logger.info('HTTP request', {
    correlationId,
    feature: 'http',
    operation: req.method,
    severity: 'low',
    url: req.urlWithParams,
  });

  return next(req).pipe(
    tap({
      next: (event) => {
        if (event.type === HttpEventType.Response) {
          logger.info('HTTP response', {
            correlationId,
            feature: 'http',
            operation: req.method,
            severity: 'low',
            status: event.status,
            durationMs: Math.round(performance.now() - startedAt),
            url: req.urlWithParams,
          });
        }
      },
      error: (error) => {
        logger.error('HTTP response error', {
          correlationId,
          feature: 'http',
          operation: req.method,
          severity: 'medium',
          status: error?.status,
          durationMs: Math.round(performance.now() - startedAt),
          url: req.urlWithParams,
        });
      },
    }),
  );
};
